<script lang="ts">
	import type { ICoinInfo } from 'customTypes/coinDetails';
	import { _ } from 'utils/i18/i18n';

	export let route;
	export let name;
	export let symbol;
	export let price;
	export let coinInfo: ICoinInfo;

	let jsonld = JSON.stringify({
		'@context': 'http://schema.org',
		'@type': 'BreadcrumbList',
		itemListElement: [
			{
				'@type': 'ListItem',
				position: 1,
				item: {
					'@id': 'https://cryptomarketcap.com/',
					name: 'Cryptocurrencies',
				},
			},
			{
				'@type': 'ListItem',
				position: 2,
				item: {
					'@id': `https://cryptomarketcap.com/coins/${route}`,
					name: `${name} Price`,
				},
			},
		],
	});

	let jsonld2 = JSON.stringify({
		'@context': 'https://schema.org',
		'@type': 'ExchangeRateSpecification',
		url: `https://cryptomarketcap.com/coins/${route}`,
		name: name,
		currency: symbol,
		currentExchangeRate: {
			'@type': 'UnitPriceSpecification',
			price: price,
			priceCurrency: 'USD',
		},
	});

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const finProduct = Object.fromEntries(Object.entries(coinInfo).filter(([_, v]) => v !== '-'));
	delete finProduct.categories;

	const jsonld3Description =
		coinInfo.hash === 'SHA-256' && coinInfo.proof === 'Proof-of-Work'
			? ' It is a native coin operating on a Proof-of-Work mechanism with a SHA-256 hash algorithm.'
			: '';
	let jsonld3 = JSON.stringify({
		'@context': 'http://schema.org/',
		'@type': 'FinancialProduct',
		name: name,
		description:
			'A cryptocurrency for secure and instant transfer of value anywhere in the world.' +
			jsonld3Description,
		category: coinInfo.categories,
		additionalType: 'Cryptocurrency',
		audience: {
			'@type': 'PeopleAudience',
			suggestedMinAge: 18,
		},
		areaServed: 'Worldwide',
		feesAndCommissionsSpecification: `https://cryptomarketcap.com/coins/${route}#fees`,
		additionalProperty: [
			...Object.entries(finProduct).map(([name, value]) => ({
				'@type': 'PropertyValue',
				name: $_(`coinDetailed.coinAbout.${name}`),
				value,
			})),
		],
	});

	const jsonldScript = `<script type="application/ld+json">${
		jsonld + '<'
	}/script><script type="application/ld+json">${jsonld2 + '<'}/script>
    <script type="application/ld+json">${jsonld3 + '<'}/script>`;
</script>

<svelte:head>
	{@html jsonldScript}
</svelte:head>
